import { render } from "./FavoriteContentsList.vue?vue&type=template&id=b974687c&ts=true"
import script from "./FavoriteContentsList.vue?vue&type=script&lang=ts"
export * from "./FavoriteContentsList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__